<!-- <body> -->
<!-- MAIN (Center website) -->

<head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
</head>
<div class="page-container">
  <div class="header">
    <div class="logo header-content"></div>
    <ul class="user-actions header-content">
      <li><a routerLink="../login"> Login</a></li>
      <li><a routerLink="/register">Register </a></li>
    </ul>
  </div>
  <div class="nav">
    <ul class="nav-options">
      <li>Our Product</li>
      <li>Plans</li>
      <li>Help</li>
      <li>Contact</li>
    </ul>
  </div>
  <div class="hero">
    <div class="container">
      <div class="hero-text">
        <h1>We empower Doctors and change them to a super doctor!</h1>
        <button class="btn primary-btn" routerLink="../Home/plans">
          Get Started
        </button>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="product">
      <h2>Why Reliable Doctors?</h2>
      <div class="row">
        <div class="product-options col-md-3 col-sm-12">
          <img src="assets/images/icon-appointment.png" />
          <h3>Appointments</h3>
          <p>Schedule and find your appointment itineraries in a few taps.</p>
        </div>
        <div class="product-options col-md-3 col-sm-12">
          <img src="assets/images/icon-health.png" />
          <h3>Health Care</h3>
          <p>Get care within hours of common ailment.</p>
        </div>
        <div class="product-options col-md-3 col-sm-12">
          <img src="assets/images/icon-test.png" />
          <h3>Lab Test</h3>
          <p>Access your lab tests anytime, anywhere.</p>
        </div>
        <div class="product-options col-md-3 col-sm-12">
          <img src="assets/images/icon-message.png" />
          <h3>Messaging</h3>
          <p>Communicate with your physician in a safe, secure way.</p>
        </div>
      </div>
    </div>
  </div>
  <div class="about">
    <div class="container">
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed elementum
        eleifend massa, eget porta magna consectetur id. In lobortis feugiat
        enim, nec fringilla turpis placerat sed. Curabitur consequat feugiat
        sem. Nam commodo leo lectus, nec aliquet ante pellentesque a.Lorem ipsum
        dolor sit amet, consectetur adipiscing elit. Sed elementum eleifend
        massa, eget porta magna consectetur id. In lobortis feugiat enim, nec
        fringilla turpis placerat sed. Curabitur consequat feugiat sem. Nam
        commodo leo lectus, nec aliquet ante pellentesque a.
      </p>
    </div>
  </div>
  <div class="container">
    <h2>Our Plans</h2>
    <div class="card-deck">
      <div id="plan-a" class="card plan-options">
        <div class="plan-bg">
          <h4>Plan-A</h4>
          <h1>&#8377; 7,999</h1>
        </div>
        <div class="card-body">
          <ul>
            <li>1 Doctor</li>
            <li>25 Patients</li>
            <li>Additional Info</li>
          </ul>
          <a href="#" class="link">Get Started</a>
        </div>
      </div>
      <div id="plan-b" class="card plan-options">
        <div class="plan-bg">
          <h4>Plan-B</h4>
          <h1>&#8377; 21,999</h1>
        </div>
        <div class="card-body">
          <ul>
            <li>3 Doctor</li>
            <li>25 Patients</li>
            <li>Additional Info</li>
          </ul>
          <a href="#" class="link">Get Started</a>
        </div>
      </div>
      <div id="plan-c" class="card plan-options">
        <div class="plan-bg">
          <h4>Plan-C</h4>
          <h1>&#8377; 34,999</h1>
        </div>
        <div class="card-body">
          <ul>
            <li>Unlimited</li>
            <li>25 Patients</li>
            <li>Additional Info</li>
          </ul>
          <a href="#" class="link">Get Started</a>
        </div>
      </div>
    </div>
  </div>
</div>